import { MapGroupId } from "../../types";
import lighthouseStashesImg from "../../mapImages/LighthouseHiddenStashes.webp";

const mapData = {
  groupId: MapGroupId.Lighthouse,
  groupName: {
    en: "Lighthouse",
    ru: "Маяк",
  },
  title: {
    en: "Hidden Stashes",
    ru: "Тайники",
  },
  imgPath: lighthouseStashesImg,
  extracts: [],
};

export default mapData;
